import React from 'react';
import { Link } from 'gatsby'; // Gatsby's Link-Komponente importieren
import LogoImageSrc from '../images/logo.svg';

const SimpleHeader = () => {
  return (
    <header className="container-xl py-8">
      <Link to="/"> {/* Link zur Startseite */}
        <img src={LogoImageSrc} alt="Logo" className="h-10 object-contain" />
      </Link>
    </header>
  );
};

export default SimpleHeader;